import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Nav, NavItem, NavLink, TabContent, TabPane, Col, Container, Row, CardBody, Card, Button } from 'reactstrap';
import classnames from 'classnames';
import AudioFileAdmisionList from './AudioFileAdmisionList';
import AudioFileAdmisionActions from './AudioFileAdmisionActions';
import AlertModal from '../../shared/components/Modal';
import Spinner from 'react-bootstrap/Spinner';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import NotificationsSockets from '../Notifications/api/NotificationsSockets';
import { NotificationsAPI } from '../Notifications/api/NotificationsAPI';
import { HTMLNotification } from '../Notifications/components/HTMLNotification';
import PDFTranscription from './PDFTranscription';
import InfoPatient from '../ClinicHistory/SearchClinicHistory/components/InfoPatient';
import { validateConfigurationsUserProfile } from '../Notifications/api/NotificationsUser';
import AudioFileAdmisionListData from './AudioFileAdmisionListData';

const AudioFileAdmision = ({ id_admision, refreshData, audioRecOpen, closeAudioRec, data, dataPatient }) => {
    const [audioRecorder, setAudioRecorder] = useState(audioRecOpen);
    const [formats, setFormats] = useState([]);
    const [userPermits, setUserPermits] = useState([]);
    const [transcriptionText, setTranscriptionText] = useState("");
    const [format, setFormat] = useState(null);
    const [colorAlertModal, setColorAlertModal] = useState(null);
    const [messagAlertModal, setMessageAlertModal] = useState(null);
    const [showAlertModal, setShowAlertModal] = useState(null);
    const [optionAlert, setOptionAlert] = useState(null);
    const [statusTranscriptionProcess, setStatusTranscriptionProcess] = useState(1);
    const [transcriptionData, setTranscriptionData] = useState(null);

    const handleChangeFormat = (formatValue) => {
        setFormat(formatValue);
        setTranscriptionText(formatValue.formato);
    }

    const validatePermissionsClinicHistory = () => {
        var user = JSON.parse(sessionStorage.getItem('usuario'));
        if (user != null) {
            if (user.perfil != undefined) {
                var perfil = user.perfil.modulos;

                console.log("userPermits", perfil);
                setUserPermits(perfil);
            } else {
                var perfil = [];
                setUserPermits(perfil);
            }
        } else {
            setUserPermits([]);
        }
    }

    const listFormatsTranscription = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'formato-resultados/listar', {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(res => {
            setFormats(res);
        }).catch(error => {
            console.log(error);
            setFormats([]);
        });
    }

    const saveTranscription = async () => {
        if (transcriptionData == null) {
            let dataSend = {
                id_admision: id_admision,
                transcripcion: transcriptionText,
                id_usuario: JSON.parse(sessionStorage.getItem('usuario')).id_usuario
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-transcripcion/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(dataTranscription => {
                sendNotificationToDoctor(dataTranscription.transcripcion).then(isNotificated => {
                    setColorAlertModal("success");
                    setMessageAlertModal("Transcripcion Realizada con Exito");
                    setOptionAlert(null);
                    setShowAlertModal(true);
                });
            }).catch(error => {
                setColorAlertModal("danger");
                setMessageAlertModal("Ha ocurrido un error en el Servidor");
                setShowAlertModal(true);
                console.log(error);
            });
        }
        else {
            let dataSend = {
                id_transcripcion: transcriptionData.id_transcripcion,
                transcripcion: transcriptionText
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-transcripcion/actualizar', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(dataTranscription => {
                sendNotificationToDoctor(dataTranscription.transcripcion).then(isNotificated => {
                    setColorAlertModal("success");
                    setMessageAlertModal("Transcripcion Realizada con Exito");
                    setOptionAlert(null);
                    setShowAlertModal(true);
                });
            }).catch(error => {
                setColorAlertModal("danger");
                setMessageAlertModal("Ha ocurrido un error en el Servidor");
                setShowAlertModal(true);
                console.log(error);
            });
        }
    }

    const changeStatusTranscription = async (statusData) => {
        if (transcriptionData != null && transcriptionData != undefined) {

            let estado_transcripcion = statusData;

            if(statusData == 4)
            {
                estado_transcripcion = 3;
            }

            let dataSend = {
                id_transcripcion: transcriptionData.id_transcripcion,
                estado_transcripcion: estado_transcripcion
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-transcripcion/actualizar-estado', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(dataTranscription => {
                let reopen = false;
                let msjAceptacion = "";
                switch (statusData) {
                    case 2:
                        msjAceptacion = "Aceptada"
                        break;
                    case 3:
                        msjAceptacion = "Rechazada"
                        break;
                    case 4:
                        reopen = true;
                        msjAceptacion = "Reabierta"
                        break;
                }

                let approve = statusData == 2 ? true : false;
                sendNotificationDoctorResponse(approve, reopen).then(isNotificated => {
                    setColorAlertModal("success");
                    setMessageAlertModal("Transcripcion " + msjAceptacion + " con Exito");
                    setOptionAlert(null);
                    setShowAlertModal(true);
                });
            }).catch(error => {
                console.log(error);
                setColorAlertModal("danger");
                setMessageAlertModal("Ha ocurrido un error en el Servidor");
                setShowAlertModal(true);
            });
        }
    }

    const sendNotificationDoctorResponse = async (approve, reopen) => {
        if (transcriptionData != null) {
            try {
                validateConfigurationsUserProfile(transcriptionData.id_usuario_transcriptor, 2).then((notConfig) => {
                    if (notConfig.not_configuracion != null && notConfig.not_configuracion != undefined) {
                        let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                        let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                        let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                        let notification = new NotificationsAPI();
                        notification.vista = false;
                        notification.id_usuario = transcriptionData.id_usuario_transcriptor;
                        notification.id_admision = transcriptionData.id_admision;
                        notification.id_historia = transcriptionData.id_historia;

                        let msjAceptacion = approve == true ? "Aceptada" : "Rechazada";
                        msjAceptacion = reopen == true ? "Reabierta" : msjAceptacion;

                        notification.asunto = "Transcripcion " + msjAceptacion;
                        notification.remitente = remitente;
                        let msjContinuo = ' la transcripción del Paciente ' + transcriptionData.nombre_paciente + ' en la Admision ';
                        notification.notificacion = msjAceptacion + msjContinuo + transcriptionData.id_admision;
                        notification.id_notificaciones_tipo = 2;
                        notification.fecha_notificacion = fecha_notificacion;
                        notification.addNotification().then((not) => {
                            let htmlNotificacion = new HTMLNotification();
                            notification.id_notificacion = not.notificacion.id_notificacion;
                            notification.html_notificacion = htmlNotificacion.notificationTranscriptionResponseDoctor(fecha_notificacion, msjAceptacion, msjContinuo, transcriptionData.id_admision);
                            notification.sendHTMLNotification().then((res_not) => {
                                NotificationsSockets.sendNotification(notification);
                                return res_not;
                            }).catch((err) => {
                                console.log(err);
                                return false;
                            });
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    return false;
                });
            }
            catch (e) {
                console.log(e);
                return false;
            }
        }
        else {
            return false
        }
    }

    const sendNotificationToDoctor = async (dataTranscription) => {
        try {
            validateConfigurationsUserProfile(dataTranscription.id_usuario, 1).then((notConfig) => {
                if (notConfig.not_configuracion != null && notConfig.not_configuracion != undefined) {
                    let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                    let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                    let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                    let notification = new NotificationsAPI();
                    notification.vista = false;
                    notification.id_usuario = dataTranscription.id_usuario;
                    notification.id_admision = dataTranscription.id_admision;
                    notification.id_historia = dataTranscription.id_historia;
                    notification.asunto = "Transcripcion en Revisión";
                    notification.remitente = remitente;
                    notification.notificacion = remitente + ' ha realizado una Transcripcion del Paciente ' + dataTranscription.nombre_paciente + ' en la Admision ' + dataTranscription.id_admision;
                    notification.id_notificaciones_tipo = 1;
                    notification.fecha_notificacion = fecha_notificacion;
                    notification.addNotification().then((not) => {
                        let htmlNotificacion = new HTMLNotification();
                        notification.id_notificacion = not.notificacion.id_notificacion;
                        notification.html_notificacion = htmlNotificacion.notificationTranscription(remitente, dataTranscription.nombre_paciente, dataTranscription.id_admision, fecha_notificacion);
                        notification.sendHTMLNotification().then((res_not) => {
                            NotificationsSockets.sendNotification(notification);
                            return res_not;
                        }).catch((err) => {
                            console.log(err);
                            return false;
                        });
                    });
                }
            }).catch((err) => {
                console.log(err);
                return false;
            });
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    const onOkModal = () => {
        switch (colorAlertModal) {
            case "success":
                setColorAlertModal("info");
                setMessageAlertModal("");
                setShowAlertModal(false);
                setOptionAlert(null);
                closeAudioRec();
                break;
            case "warning":
                if (optionAlert == 1) {
                    saveTranscription();
                }
                else if (optionAlert == 2) {
                    changeStatusTranscription(2);
                }
                else if (optionAlert == 3) {
                    changeStatusTranscription(3);
                }
                else if (optionAlert == 4) {
                    changeStatusTranscription(4);
                }
                refreshData();
                break;
            case "danger":
                setColorAlertModal("info");
                setMessageAlertModal("");
                setShowAlertModal(false);
                setOptionAlert(null);
                break;
        }
    }

    const onToggleModal = () => {
        switch (colorAlertModal) {
            case "success":
                setColorAlertModal("info");
                setMessageAlertModal("");
                setShowAlertModal(false);
                setOptionAlert(null);
                closeAudioRec();
                break;
            case "warning":
                setColorAlertModal("info");
                setMessageAlertModal("");
                setShowAlertModal(false);
                setOptionAlert(null);
                break;
            case "danger":
                setColorAlertModal("info");
                setMessageAlertModal("");
                setShowAlertModal(false);
                setOptionAlert(null);
                break;
        }
        refreshData();
    }

    const getTranscription = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-transcripcion/consultar?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error");
            }
        }).then(res => {
            if (res.transcripcion != null && res.transcripcion != undefined) {
                setStatusTranscriptionProcess(res.transcripcion.estado_transcripcion);
                setTranscriptionData(res.transcripcion);
                setTranscriptionText(res.transcripcion.transcripcion);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    const printTranscription = async () => {
        if (transcriptionData != null) {
            let today = moment().tz("America/Bogota").format("DD-MM-YYYY HH:mm:ss");
            await fetch(process.env.REACT_APP_PUBLIC_URL + `admision-transcripcion/consultar-impresion?id_admision=${transcriptionData.id_admision}&id_transcripcion=${transcriptionData.id_transcripcion}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => response.json()).then(res => {
                let dataQuery = res.info;
                let perfil = JSON.parse(sessionStorage.getItem('clinica'));
                let genderDoctor = dataQuery.sexo_doctor;
                let prefixDoctor = 'Dr. ';
                switch (genderDoctor) {
                    case 'Masculino':
                        prefixDoctor = 'Dr. ';
                        break;
                    case 'Femenino':
                        prefixDoctor = 'Dra. ';
                        break;
                }
                let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
                let firmDoctor = process.env.REACT_APP_PUBLIC_URL + dataQuery.url_firma_doctor + '/' + sessionStorage.getItem('token');
                let firmDoctorSupport = process.env.REACT_APP_PUBLIC_URL + dataQuery?.medico_apoyo?.url_firma_doctor_alter + '/' + sessionStorage.getItem('token');

                console.log("dataQuery", dataQuery.servicio.servicios[0]);

                let nameService = dataQuery.servicio.servicios[0].nombre;
                let codigoService = dataQuery.servicio.servicios[0].codigo;

                const dataPrint = {
                    today: today,
                    fullname: dataQuery.fullname,
                    documentNumber: dataQuery.num_documento,
                    typeDocument: dataQuery.tip_documento,
                    profile: perfil,
                    birthday: moment(dataQuery.fec_nacimiento).format('YYYY-MM-DD'),
                    age: dataQuery.edad,
                    gender: dataQuery.sexo,
                    address: dataQuery.direccion.direccion,
                    city: dataQuery.direccion.ciudad,
                    telephone: dataQuery.telefono1,
                    nitThird: dataQuery.nit_tercero,
                    nameThird: dataQuery.nombre_tercero,
                    regime: dataQuery.regimen_paciente,
                    urlLogo: sessionStorage.getItem('logoURL'),
                    transcription: dataQuery.transcripcion,
                    nameDoctor: nameDoctor,
                    specialtyDoctor: dataQuery.especialidad_doctor,
                    medicalRegister: dataQuery.reg_medico,
                    urlDoctorFirm: firmDoctor,
                    nameService: nameService,
                    codigoService: codigoService,
                    id_admision: transcriptionData.id_admision,
                    fecha_admision: dataQuery.fecha_admision,
                    celular: dataQuery.celular,
                    suportDoc: dataQuery.medico_apoyo || null,
                    firmDoctorSupport
                };
                PDFTranscription(dataPrint);
            }).catch(error => {
                console.log(error);
            });
        }
    }

    useEffect(() => {
        listFormatsTranscription();
        validatePermissionsClinicHistory();
        getTranscription();
    }, []);

    return (
        <Fragment>
            <Modal
                open={audioRecorder}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="paperAppointment-flex-wider" style={{ width: '100%', margin: 10, height: '90%', overflowY: "auto" }}>
                    <Row>
                        <Col md={8}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div className="card__title">
                                    <h4 className="bold-text">Generar Transcripción</h4>
                                </div>
                                <div>
                                    <InfoPatient dataPatient={dataPatient} />
                                </div>
                                <div style={{ width: '80%' }}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="transcriptionFormat"
                                        label="Formato de Transcripción"
                                        select
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                        disabled={statusTranscriptionProcess == 2}
                                        value={format}
                                        onChange={(e) => {
                                            handleChangeFormat(e.target.value);
                                        }}
                                    >
                                        {formats.map((format) => {
                                            return <MenuItem key={format.id_formato} value={format}>{format.nombre}</MenuItem>
                                        })}
                                    </TextField>
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <AudioFileAdmisionListData id_admision={id_admision} />
                        </Col>
                    </Row>

                    <Row style={{ margin: '0.5em 0em' }}>
                        <Col md={12} style={{ paddingLeft: 0, marginTop: '0.5em' }}>
                            <div className="form" style={{ width: '100%' }}>
                                {/* <div className="form__half" style={{ width: '100%' }}> */}
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Transcripción</span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            disabled={statusTranscriptionProcess == 2 || (statusTranscriptionProcess == 1 && transcriptionData != null)}
                                            style={{ width: '100%', height: '400px', fontSize: '16px' }}
                                            value={transcriptionText}
                                            onChange={(event) => { setTranscriptionText(event.target.value) }}
                                            required={true}>
                                        </textarea>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                        </Col>
                    </Row>


                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            //Si es un Transcriptor y el Estado esta en Pendiente
                            (statusTranscriptionProcess == 1 && transcriptionData == null) || (statusTranscriptionProcess == 3 && transcriptionData != null) ? <>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="primary"
                                    onClick={() => {
                                        setColorAlertModal("warning");
                                        setMessageAlertModal("Esta completamente seguro de enviar esta transcripcion?");
                                        setOptionAlert(1);
                                        setShowAlertModal(true);
                                    }}
                                >
                                    Guardar para Revisión
                                </Button>
                            </> : null
                        }
                        {
                            //Si es un Doctor puede Aprobar o Rechazar
                            (statusTranscriptionProcess == 1 || statusTranscriptionProcess == 3) && userPermits.includes(31) && transcriptionData != null ? <>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="success"
                                    onClick={() => {
                                        setColorAlertModal("warning");
                                        setMessageAlertModal("Esta completamente seguro de APROBAR esta transcripción? Al hacerlo se cerrara la Historia Clinica");
                                        setOptionAlert(2);
                                        setShowAlertModal(true);
                                    }}
                                >
                                    Aprobar
                                </Button>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="danger"
                                    onClick={() => {
                                        setColorAlertModal("warning");
                                        setMessageAlertModal("Esta completamente seguro de RECHAZAR esta transcripción?");
                                        setOptionAlert(3);
                                        setShowAlertModal(true);
                                    }}
                                >
                                    Rechazar
                                </Button>
                            </> : null
                        }

                        {
                            userPermits.includes(58) && statusTranscriptionProcess == 2 ? <>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="primary"
                                    onClick={() => {
                                        setColorAlertModal("warning");
                                        setMessageAlertModal("Esta completamente seguro de REABRIR esta transcripción?");
                                        setOptionAlert(4);
                                        setShowAlertModal(true);
                                    }}
                                >
                                    Reabrir Transcripción
                                </Button>
                            </> : null
                        }

                        {
                            statusTranscriptionProcess == 2 && transcriptionData != null ? <Button
                                style={{ marginTop: 10 }}
                                color="primary"
                                onClick={() => {
                                    printTranscription();
                                }}
                            >
                                Imprimir
                            </Button> : null
                        }
                        <Button
                            style={{ marginTop: 10 }}
                            color="btn btn-secondary"
                            onClick={() => {
                                closeAudioRec();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>


            <AlertModal
                color={colorAlertModal}
                title={messagAlertModal}
                modal={showAlertModal}
                onOk={() => {
                    onOkModal();
                }}
                toggle={() => {
                    onToggleModal();
                }}
            />

        </Fragment>)
}

export default AudioFileAdmision;